import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { TeamContainer, Wrapper } from "./styles"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Card from "./Card"
import TeamWaves from "../../img/team_waves.svg"

const TEAM_QUERY = graphql`
  query MyQuery {
    agilityTeam {
      customFields {
        title
      }
      linkedContent_teamMembers {
        customFields {
          name
          position
          bio
          imageLocalImg {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

const Team = () => {
  // get data
  const data = useStaticQuery(TEAM_QUERY)

  // slider settings
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <TeamContainer img={TeamWaves}>
      <Wrapper>
        <h3>{data.agilityTeam.customFields.title}</h3>
        <Slider {...settings}>
          {data.agilityTeam.linkedContent_teamMembers.map((member, i) => (
            <Card member={member} key={i} />
          ))}
        </Slider>
      </Wrapper>
    </TeamContainer>
  )
}

export default Team
